module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-4">\n        <p class="intro">With Creator\'s Custom JavaScript Action, you can create your own JavaScript Actions for your Creator Experiences.</p>\n        <p>This will allow you to create advanced JavaScript Actions with support for runtime parameters to integrate directly with your site, for example calling a JavaScript method to open a QuickView, adding even more dynamic behavior and interactive features for your Creator Experiences.</p>\n        <p>By naming the Action, you will easily be able to find it in the Action Menu inside the Editor when you\n        are assigning actions to Widgets. </p>\n\n        ';
 if (cannotCreateNew) { ;
__p += '\n        <p>You must be a <a href="#manageAccount">Manager</a> to create, modify, or delete Actions. </p>\n        ';
 } ;
__p += '\n\n        <div class="notification-box">\n            <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">JavaScript Actions In Use Cannot Be Changed</span>\n            <p>A JavaScript Action used in Experiences is not editable, nor deletable. You will have to remove the Action from the Experiences in question, or delete the Experiences, to be able to further edit the Action. Click the <img src="images/integration/customjavascript/lock.png"> to see which Experiences use the Action.</p>\n        </div>\n    </div>\n\n    <div class="col-xs-8">\n        <h4>Your JavaScript Actions</h4>\n\n        <div class="custom-js-add-container">\n            <button class="pull-right btn btn-secondary new-custom-js';
 if (cannotCreateNew) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (cannotCreateNew) { ;
__p += ' disabled';
 } ;
__p += '>&#43; Create New Action</button>\n            ';
 if (!cannotCreateNew) { ;
__p += '\n                <p>Click "Create New Action" and follow the steps to create a new Custom JavaScript Action.</p>\n            ';
 } ;
__p += '\n        </div>\n\n        <div class="custom-js-list"></div>\n\n        <div class="custom-js-setup-illustration"></div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/integrations/customJs/CustomJsView.tpl
// module id = 3074
// module chunks = 0